<template>
  <div class="focusBox">
    <div class="focusPic">
      <van-image :src="focusData.headPicture">
        <template v-slot:loading>
          <van-loading type="spinner" color="#0094ff" size="20" />
        </template>
        <template v-slot:error>加载失败~</template>
      </van-image>
      <div class="focusTitle">
        {{ focusData.title }}
      </div>
      <a
        href="https://a.app.qq.com/o/simple.jsp?pkgname=com.v1.video"
        class="btn"
        >参与</a
      >
    </div>
    <div class="van-multi-ellipsis--l2 abstract">
      {{ focusData.introduction }}
    </div>
  </div>
</template>
<script>
import { Image as VanImage, Loading } from "vant";
export default {
  name: "focus",
  components: { VanImage, vanLoading: Loading },
  props: ["focusData"],
  data() {
    return {};
  },
};
</script>
<style scoped>
/* .focusPic {
  width: 100%;
  height: 0;
  position: relative;
  overflow: hidden;
  padding-bottom: 53%;
}
.focusPic img {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  object-fit: cover;
} */
.focusTitle {
  padding: 0 95px 0 15px;
  position: absolute;
  z-index: 2;
  width: 100%;
  box-sizing: border-box;
  left: 0%;
  bottom: 15px;
  font-size: 18px;
  line-height: 19px;
  color: #ffffff;
}
.btn {
  display: block;
  width: 68px;
  height: 38px;
  position: absolute;
  z-index: 2;
  bottom: 10px;
  right: 15px;
  background: url(../../assets/images/btn_bg_s.png) no-repeat 0 0;
  background-size: 100%;
  text-align: center;
  line-height: 38px;
  color: #ffffff;
}
.abstract {
  margin: 15px;
  /* padding:0 15px; */
  font-size: 12px;
  line-height: 18px;
  color: #666666;
}
</style>